import React, { FC, ReactNode, useEffect, useRef } from "react";
import cn from 'classnames';
import { useDebounceFn } from "ahooks";
import { takeSnapshot } from "../../utils/punch";
import { postTakeSnapshot, postUploadFile } from "../../api";
import styles from './index.module.scss';

interface SnapshotWrapperProps {
  children: ReactNode;
  className?: string;
  courseInfo: {
    course_no: string;
    page_id: number;
    step: number;
  }
}

const SnapshotWrapper: FC<SnapshotWrapperProps> = ({
  children,
  className,
  courseInfo,
}) => {
  const ref = useRef(null);
  const [shotting, setShotting] = React.useState(false);

  const { run: uploadSnapshot } = useDebounceFn(() => {
    if (process.env.NODE_ENV === 'development') return;
    setShotting(true);
    setTimeout(async () => {
      try {
        if (!ref.current) return;
        const snapshot = await takeSnapshot(ref.current);
        if (!snapshot) return;
        setShotting(false);
        // dataurl to file blob
        const { course_no, page_id, step } = courseInfo;
        const filename = `course${course_no}-page${page_id}-step${step}.png`
        const file = await fetch(snapshot)
          .then(r => r.blob())
          .then(blob => {
            return new File([blob], filename, { type: 'image/png' });
          });
        const res = await postUploadFile(file);
        const { file_key } = res;
        await postTakeSnapshot({
          ...courseInfo,
          file: file_key,
        });
      } catch (e) {
        console.error(e);
      } finally {
        setShotting(false);
      }
    }, 0);

  }, { wait: 1000 })

  useEffect(() => {
    setTimeout(() => {
      uploadSnapshot();
    }, 1000);
  }, [uploadSnapshot, courseInfo]);

  return (
    <div
      className={cn(
        styles.snapshot,
        className,
        shotting && styles.shotting,
      )}
      ref={ref}
    >
      {children}
    </div>
  )
}

export default SnapshotWrapper;
